import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_layout_header = _resolveComponent("layout-header")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_layout_left_menu = _resolveComponent("layout-left-menu")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "hHh lpR fFf" }, {
    default: _withCtx(() => [
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_q_header, {
            key: 0,
            class: "bg-primary text-white",
            elevated: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    flat: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDrawerOpen = !_ctx.isDrawerOpen)),
                    round: "",
                    dense: "",
                    icon: "menu"
                  }),
                  _createVNode(_component_layout_header)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_q_drawer, {
            key: 1,
            "show-if-above": "",
            modelValue: _ctx.isDrawerOpen,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isDrawerOpen) = $event)),
            side: "left",
            bordered: "",
            class: "bg-secondary text-white"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_layout_left_menu)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_Suspense, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}